import { render } from "./OffersView.vue?vue&type=template&id=4f038017&scoped=true"
import script from "./OffersView.vue?vue&type=script&lang=js"
export * from "./OffersView.vue?vue&type=script&lang=js"

import "./OffersView.vue?vue&type=style&index=0&id=4f038017&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f038017"]])

export default __exports__